import { render, staticRenderFns } from "./estimation-module.vue?vue&type=template&id=32b16e1c&scoped=true&"
import script from "./estimation-module.vue?vue&type=script&lang=ts&"
export * from "./estimation-module.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b16e1c",
  null
  
)

export default component.exports